import { getColor } from 'common/constants/_colors';
import StackedAreaChart from 'components/StackedAreaChart';
import { PROJECTS } from '../services/projects.services';

const lineChartSingleSeries = (
  data,
  color = 'melrose',
  dashStyle = 'solid'
) => {
  // In order to display the line markers on the same vertical line as the column charts below,
  // we create transparent column series
  return [
    {
      data,
      color: 'transparent',
      stack: 1,
      type: 'column',
      yAxis: 0
    },
    {
      data,
      dashStyle,
      lineColor: getColor(color),
      lineWidth: 1,
      marker: {
        enabled: true,
        symbol: 'circle',
        radius: 3,
        fillColor: 'white',
        lineColor: getColor(color),
        lineWidth: 2
      },
      type: 'line'
    }
  ];
};

export const lineChartOptionsSeries = ({ lineChartData }) =>
  lineChartData.flatMap(({ key, color, dashStyle, iterationsTotals }) => {
    return lineChartSingleSeries(iterationsTotals, color, dashStyle);
  });

const DeliveryTypeChartColumn = ({ lineChartData, isMax100Percent }) => {
  const lineChartOptions = {
    chart: {
      backgroundColor: null,
      margin: PROJECTS.LARGE_CHART_MARGIN
    },
    xAxis: {
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      minorTickLength: 0,
      tickLength: 0,
      lineWidth: 1,
      labels: {
        enabled: false
      }
    },
    yAxis: [
      {
        tickInterval: 10,
        lineWidth: 0,
        gridLineWidth: 0,
        ...(isMax100Percent && { max: 100 }),
        title: {
          enabled: false
        },
        labels: {
          enabled: true,
          style: PROJECTS.CHART_STYLE
        }
      },
      {
        visible: false
      }
    ],
    series: lineChartOptionsSeries({ lineChartData })
  };
  return (
    <StackedAreaChart chartOptionsProp={lineChartOptions} showLegend={false} />
  );
};

export default DeliveryTypeChartColumn;
